var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "faq-wrapper" }, [
    _c(
      "div",
      { staticClass: "content-container m-auto" },
      [
        _c(
          "div",
          { staticClass: "font-tragic-marker text-center faq-preheader" },
          [
            _vm._v(
              " " +
                _vm._s(_vm.$t("pages.pricing.faq.doYouHaveAnyConcerns")) +
                " "
            ),
          ]
        ),
        _c("h1", { staticClass: "d-lg-none text-center faq-header" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("pages.pricing.faq.hereSTheListOf")) +
              " " +
              _vm._s(_vm.$t("pages.pricing.faq.frequentlyAskedQuestions")) +
              " "
          ),
        ]),
        _c(
          "h1",
          { staticClass: "d-none d-lg-block text-center faq-header" },
          [
            _vm._v(
              " " + _vm._s(_vm.$t("pages.pricing.faq.hereSTheListOf")) + " "
            ),
            _c("underlined-text", { staticClass: "px-1 py-2" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("pages.pricing.faq.frequentlyAskedQuestions")) +
                  " "
              ),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          { attrs: { gutter: 20 } },
          [
            _c(
              "el-col",
              { attrs: { md: 12 } },
              [
                _c(
                  "el-collapse",
                  [
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.lifetimeFaq.whatDoesTheLifetimeDealInclude"
                          ),
                          name: "1",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "pages.pricing.lifetimeFaq.lifetimeDealsIsSpecial"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.lifetimeFaq.ifIPurchaseYourLtdAmIGoingToBeAdditionallyCharged"
                          ),
                          name: "2",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "pages.pricing.lifetimeFaq.noOnceYouPurchase"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title:
                            "Will I be able to upgrade to a higher plan if I want?",
                          name: "3",
                        },
                      },
                      [
                        _vm._v(
                          " Of course! In case you want to have more ideas or collaborators, just contact us via chat or contact@ideabuddy.com and we will help you with the upgrade. You will just pay the difference, without any additional monthly/yearly charges. "
                        ),
                      ]
                    ),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.lifetimeFaq.whatIsYourRefundPolicy"
                          ),
                          name: "4",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "pages.pricing.lifetimeFaq.weHaveA30DayRefundPolicy"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.lifetimeFaq.doYouHaveAnAffiliateProgram"
                          ),
                          name: "5",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "pages.pricing.lifetimeFaq.yesIfYouAreInterestedInWorkingWithUs"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.faq.howDoYouDefineAnIdeaSlot"
                          ),
                          name: "6",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("pages.pricing.faq.anIdeaSlotCanBeAnyType")
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.faq.isAiAssistanceAvailableWithAnyPlan"
                          ),
                          name: "7",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "pages.pricing.faq.aIAssistanceIsAvailableWithAllPlans"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { md: 12 } },
              [
                _c(
                  "el-collapse",
                  [
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.faq.whichPaymentTypesAreSupported"
                          ),
                          name: "6",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("pages.pricing.faq.weAcceptPurchasesVia")
                            ) +
                            " "
                        ),
                        _c(
                          "el-row",
                          [
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("ul", [
                                _c("li", [_vm._v("Mastercard")]),
                                _c("li", [_vm._v("Visa")]),
                                _c("li", [_vm._v("Maestro")]),
                                _c("li", [_vm._v("American Express")]),
                                _c("li", [_vm._v("Discover")]),
                                _c("li", [_vm._v("Diners Club")]),
                              ]),
                            ]),
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("ul", [
                                _c("li", [_vm._v("JCB")]),
                                _c("li", [_vm._v("PayPal")]),
                                _c("li", [
                                  _vm._v(
                                    "Apple Pay (The Apple Pay option will only appear at checkout for one-time payments to customers using the Safari browser with Apple Pay set up on their device)"
                                  ),
                                ]),
                                _c("li", [
                                  _vm._v("Wire Transfers (ACH/SEPA/BACS)"),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.lifetimeFaq.willIGetAccessToAllFutureUpdatesAndFeatures"
                          ),
                          name: "7",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "pages.pricing.lifetimeFaq.youWillGetAllFutureUpdatesAndFeatures"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.lifetimeFaq.howDoesIdeaBuddyCompareToOtherBusinessPlanningTools"
                          ),
                          name: "8",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "pages.pricing.lifetimeFaq.theBiggestValueOfIdeaBuddy"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.lifetimeFaq.isMyDataSafeAndSecure"
                          ),
                          name: "9",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "pages.pricing.lifetimeFaq.weFullyProtectYourPersonalInformation"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.lifetimeFaq.whatIfIHaveSomeAdditionalQuestions"
                          ),
                          name: "10",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "pages.pricing.lifetimeFaq.weWillBeHappyToAnswerThoseForYou"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.faq.whatIsTheValidityOfAi"
                          ),
                          name: "11",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("pages.pricing.faq.theValidityOfAiRequest")
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: _vm.$t(
                            "pages.pricing.faq.howToRefillTheCredit"
                          ),
                          name: "12",
                        },
                      },
                      [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "pages.pricing.faq.youCanEasilyRefillTheCredit"
                              )
                            ),
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }